const en = {
  lng_name: 'English',
  item_id_does_not_exist: 'Item {{id}} does not exist in your Kaltura item list or has been deleted.',
  your_kaltura_item_list_is_empty: 'Your kaltura item list is empty.',
  purchase: 'purchase',
  purchased: 'purchased',
  go_to: 'Go to',
  login_signup: 'Login/Signup',
  logout: 'Logout',
  please_wait: 'Please wait...',
  thank_you_for_your_purchase: 'Thank you for your purchase',
  buy_more_channels: 'Buy more channels',
  go_to_premium_content: 'Go to premium content',
  go_to_purchased_channels: 'Go to purchased channels',
};

export default en;